import React, { FC, ReactNode } from "react";

export interface IContentStep {
  children: ReactNode;
  index?: number;
  isFirst?: boolean;
  isLast?: boolean;
  className?: string;
}

export const ContentStep: FC<IContentStep> = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};

ContentStep.displayName = "ContentStep";
